import { render, staticRenderFns } from "./lazyblock_last_recipes_by_category.vue?vue&type=template&id=afd530b0&scoped=true"
import script from "./lazyblock_last_recipes_by_category.vue?vue&type=script&lang=js"
export * from "./lazyblock_last_recipes_by_category.vue?vue&type=script&lang=js"
import style0 from "./lazyblock_last_recipes_by_category.vue?vue&type=style&index=0&id=afd530b0&prod&lang=scss&scoped=true"
import style1 from "./lazyblock_last_recipes_by_category.vue?vue&type=style&index=1&id=afd530b0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afd530b0",
  null
  
)

export default component.exports